<template>
  <el-tooltip class="item" effect="dark" :content="tipContent" placement="top">
    <i class="el-icon-question"></i>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    tipContent: String
  }
}
</script>